import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createCatalogoModel } from '../utils/catalogoUtils';

// idb store name
const storeName = 'catalogos';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'catalogo';

export const catalogoService = {
  getCatalogos,
  getCatalogosAPI,
  getCatalogo,
  addCatalogo,
  addCatalogos,
  updateCatalogo,
  compareAndUpdateCatalogos
};

function getCatalogos() {
  return getIndexedDBCatalogos();
}

async function getCatalogosAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_catalogo",
      "catalogo",
      "estrutura"
    ],
    filtros: [
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const catalogosApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateCatalogos(catalogosApi);
  await removeInexistentes(catalogosApi);
  return catalogosApi;
}

function getIndexedDBCatalogos() {
  return idbService.getAll(storeName);
}

function getCatalogo(id) {
  return idbService.getById(storeName, id);
}

async function compareAndUpdateCatalogos(catalogos) {
  if (catalogos && catalogos.length) {
    for (const catalogo of catalogos) {
      const savedCatalogo = await getCatalogo(catalogo.id_catalogo);
  
      if (!savedCatalogo) {
        catalogo.versao_imp = 1;
        await addCatalogo(catalogo);
      } else {
        catalogo.versao_imp = savedCatalogo.versao_imp ? savedCatalogo.versao_imp + 1 : 1;
        await updateCatalogo(catalogo);
      }
    }
  } else {
    // Limpa os registros do store catalogos
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(catalogosApi) {
  if (catalogosApi && catalogosApi.length) {
    const idsCatalogosApi = catalogosApi.map(catalogoApi => catalogoApi.id_catalogo);
    const catalogosLocal = await idbService.getAll(storeName);
    const catalogosInexistentes = catalogosLocal.filter(catalogoLocal => !idsCatalogosApi.includes(catalogoLocal.id_catalogo));
    if (catalogosInexistentes && catalogosInexistentes.length) {
      for (const catalogo of catalogosInexistentes) {
        await idbService.deleteFromStore(storeName, catalogo.id_catalogo);
      }
    }
  } else {
    return;
  }
}

async function addCatalogo(catalogo) {
  const parsedCatalogo = createCatalogoModel(catalogo);
  return idbService.addToStore(storeName, parsedCatalogo);
}

async function addCatalogos(catalogos = []) {
  const parsedCatalogos = catalogos.map(catalogo => createCatalogoModel(catalogo));
  return idbService.addMultipleToStore(storeName, parsedCatalogos);
}

async function updateCatalogo(catalogo) {
  const parsedCatalogo = createCatalogoModel(catalogo);
  await idbService.updateItem(storeName, parsedCatalogo);
}